import { Component, Input, OnInit } from '@angular/core';
import { FunctionalCapabilitiesIntroductionSection } from 'src/app/model/shared/functional-capabilities-introduction-section';

@Component({
  selector: 'app-functional-capabilities-introduction-section',
  templateUrl: './functional-capabilities-introduction-section.component.html',
  styleUrls: ['./functional-capabilities-introduction-section.component.scss']
})
export class FunctionalCapabilitiesIntroductionSectionComponent implements OnInit {
  @Input() sections: FunctionalCapabilitiesIntroductionSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
